import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface ChateauImage {
  id: string;
  image_url: string;
  alt_text?: string;
  is_primary: boolean;
  display_order: number;
}

export const useChateauImages = (chateauId: string) => {
  const [images, setImages] = useState<ChateauImage[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadImages = async () => {
    if (!chateauId) {
      setImages([]);
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const { data, error } = await supabase
        .from('chateau_images')
        .select('*')
        .eq('chateau_id', chateauId)
        .order('is_primary', { ascending: false })
        .order('display_order', { ascending: true });

      if (error) throw error;

      console.log('[useChateauImages] Loaded images for chateau:', chateauId, data);
      setImages(data || []);
      setError(null);
    } catch (err) {
      console.error('Erreur lors du chargement des images:', err);
      setError(err instanceof Error ? err.message : 'Erreur inconnue');
      setImages([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadImages();
  }, [chateauId]);

  const refreshImages = () => {
    loadImages();
  };

  // Return image URLs for compatibility with existing components
  const imageUrls = images.map(img => img.image_url);

  return {
    images,
    imageUrls,
    isLoading,
    error,
    refreshImages
  };
};